<template>
  <v-main>
  </v-main>
</template>

<script>
export default {
  name: 'view-dialer'
}
</script>

<style scoped>
</style>
